import React, { useEffect } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import "./styles/style.css";

import TableDestinatarios from "../components/Tables/TableDestinatarios/TableDestinatarios";
// import TableCancelaciones from "../../components/Tables/TableCancelaciones/TableCancelaciones";
// import TableRecolecciones from "../../components/Tables/TableRecolecciones/TableRecolecciones";
import usePostDestinatarios from "../hooks/destinatarios/usePostDestinatarios";
import useGetDestinatarios from "../hooks/destinatarios/useGetDestinatarios";
import usePatchDestinatarios from "../hooks/destinatarios/usePatchDestinatarios";
import useDeleteDestinatarios from "../hooks/destinatarios/useDeleteDestinatarios";

const Destinatarios = () => {
  
  const [{ data: update }, doPost] = usePostDestinatarios();
  const [
    { data: destinatarios, isLoading: isDestinatariosLoading },
    doGet
  ] = useGetDestinatarios("");
  const [{ data: patch }, doPatch] = usePatchDestinatarios();
  const [{ data: deleted }, doDelete] = useDeleteDestinatarios();

  useEffect(() => {
    doGet(Math.random());
    // console.log(Destinatarios);
  }, [update, patch, deleted,doGet]);

  return isDestinatariosLoading ? (
    <CircularProgress />
  ) : (
    <Grid container spacing={2}>
      <TableDestinatarios
        data={destinatarios}
        onAdd={doPost}
        onUpdate={doPatch}
        onDelete={doDelete}
      />
    </Grid>
  );
};

export default Destinatarios;
